import React, { useState } from 'react';

const phoneModels = ['iPhone 11', 'iPhone 11 Pro', 'iPhone 12', 'iPhone 12 Pro', 'iPhone 13', 'iPhone 13 Pro', 'iPhone 14', 'iPhone 14 Pro', 'iPhone 15', 'iPhone 15 Pro', 'iPhone 16', 'iPhone 16 Pro'];
const phoneColors = ['Black', 'White', 'Gold', 'Silver', 'Blue', 'Purple', 'Green', 'Red'];
const phoneStorages = ['64GB', '128GB', '256GB', '512GB', '1TB'];

const PhoneForm = () => {
  const [phone, setPhone] = useState({ imei: '', brand: 'Apple', model: '', color: '', storage: '' });
  const [bulkImeis, setBulkImeis] = useState('');
  const [bulkModel, setBulkModel] = useState('');
  const [bulkColor, setBulkColor] = useState('');
  const [bulkStorage, setBulkStorage] = useState('');
  const [file, setFile] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [activeTab, setActiveTab] = useState('single');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPhone(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (phone.imei.length !== 15) {
      alert('El IMEI debe tener exactamente 15 dígitos');
      return;
    }
    try {
      const response = await fetch('backend/phones.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ ...phone }),
      });
      const result = await response.json();
      if (result.success) {
        alert('Dispositivo registrado correctamente');
        setPhone({ imei: '', brand: 'Apple', model: '', color: '', storage: '' });
      } else {
        alert(result.error || 'Error al registrar teléfono');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleBulkSubmit = async (e) => {
    e.preventDefault();
    if (!bulkModel || !bulkColor || !bulkStorage) {
      alert('Por favor complete modelo, color y almacenamiento para todos los teléfonos');
      return;
    }

    const imeis = bulkImeis.split('\n').map(imei => imei.trim()).filter(imei => imei.length > 0);
    const invalidImeis = imeis.filter(imei => imei.length !== 15);
    if (invalidImeis.length > 0) {
      alert(`Los siguientes IMEI no tienen 15 dígitos:\n${invalidImeis.join('\n')}`);
      return;
    }

    const newPhones = imeis.map(imei => ({ imei, brand: 'Apple', model: bulkModel, color: bulkColor, storage: bulkStorage }));

    try {
      const response = await fetch('backend/phones.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(newPhones),
      });
      const result = await response.json();
      if (result.success) {
        alert('Dispositivos registrados correctamente');
        setBulkImeis('');
        setBulkModel('');
        setBulkColor('');
        setBulkStorage('');
      } else {
        alert(result.error || 'Error al registrar Dispositivos');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleFileChange = (e) => setFile(e.target.files[0]);

  const handleFileUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      alert('Por favor seleccione un archivo CSV o Excel');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    try {
      const response = await fetch('backend/import_phones.php', {
        method: 'POST',
        body: formData,
        credentials: 'include',
      });
      const result = await response.json();
      if (result.success) {
        alert('Teléfonos importados correctamente');
        setFile(null);
      } else {
        alert(result.error || 'Error al importar teléfonos');
      }
    } catch (error) {
      console.error('Error al importar:', error);
    }
  };

  const handleExport = (type) => {
    if (!startDate || !endDate) {
      alert('Por favor seleccione un rango de fechas');
      return;
    }
    window.location.href = `backend/export_report.php?type=${type}&startDate=${startDate}&endDate=${endDate}`;
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <div className="flex border-b border-gray-200 mb-6">
        <button type="button" className={`py-2 px-4 font-medium text-sm ${activeTab === 'single' ? 'border-b-2 border-[#31a749] text-[#31a749]' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('single')}>Registro Individual</button>
        <button type="button" className={`py-2 px-4 font-medium text-sm ${activeTab === 'bulk' ? 'border-b-2 border-[#31a749] text-[#31a749]' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('bulk')}>Registro Masivo</button>
        <button type="button" className={`py-2 px-4 font-medium text-sm ${activeTab === 'import' ? 'border-b-2 border-[#31a749] text-[#31a749]' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('import')}>Importar desde Archivo</button>
        <button type="button" className={`py-2 px-4 font-medium text-sm ${activeTab === 'export' ? 'border-b-2 border-[#31a749] text-[#31a749]' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('export')}>Exportar Reportes</button>
      </div>

      {activeTab === 'single' && (
        <form onSubmit={handleSubmit}>
          <h2 className="text-xl font-semibold mb-4">Registro Individual de Dispositivos</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Número IMEI (15 dígitos)</label>
              <input type="text" name="imei" value={phone.imei} onChange={handleChange} maxLength="15" className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#31a749] focus:border-[#31a749]" required />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Modelo</label>
              <select name="model" value={phone.model} onChange={handleChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#31a749] focus:border-[#31a749]" required>
                <option value="">Seleccione un modelo</option>
                {phoneModels.map(model => (<option key={model} value={model}>{model}</option>))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Color</label>
              <select name="color" value={phone.color} onChange={handleChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#31a749] focus:border-[#31a749]" required>
                <option value="">Seleccione un color</option>
                {phoneColors.map(color => (<option key={color} value={color}>{color}</option>))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Almacenamiento</label>
              <select name="storage" value={phone.storage} onChange={handleChange} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#31a749] focus:border-[#31a749]" required>
                <option value="">Seleccione almacenamiento</option>
                {phoneStorages.map(storage => (<option key={storage} value={storage}>{storage}</option>))}
              </select>
            </div>
          </div>
          <button type="submit" className="mt-4 bg-[#31a749] text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#31a749]">Registrar Teléfono</button>
        </form>
      )}

      {activeTab === 'bulk' && (
        <form onSubmit={handleBulkSubmit}>
          <h2 className="text-xl font-semibold mb-4">Registrar Teléfonos en Masa</h2>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">IMEIs (uno por línea, 15 dígitos cada uno)</label>
            <textarea value={bulkImeis} onChange={(e) => setBulkImeis(e.target.value)} rows={5} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#31a749] focus:border-[#31a749]" placeholder="Ejemplo:\n123456789012345\n987654321098765\n..." required />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Modelo</label>
              <select value={bulkModel} onChange={(e) => setBulkModel(e.target.value)} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#31a749] focus:border-[#31a749]" required>
                <option value="">Seleccione un modelo</option>
                {phoneModels.map(model => (<option key={model} value={model}>{model}</option>))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Color</label>
              <select value={bulkColor} onChange={(e) => setBulkColor(e.target.value)} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#31a749] focus:border-[#31a749]" required>
                <option value="">Seleccione un color</option>
                {phoneColors.map(color => (<option key={color} value={color}>{color}</option>))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Almacenamiento</label>
              <select value={bulkStorage} onChange={(e) => setBulkStorage(e.target.value)} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-[#31a749] focus:border-[#31a749]" required>
                <option value="">Seleccione almacenamiento</option>
                {phoneStorages.map(storage => (<option key={storage} value={storage}>{storage}</option>))}
              </select>
            </div>
          </div>
          <button type="submit" className="mt-4 bg-[#31a749] text-white py-2 px-4 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#31a749]">
            Registrar {bulkImeis.split('\n').filter(imei => imei.trim().length > 0).length} Teléfonos
          </button>
        </form>
      )}

      {activeTab === 'import' && (
        <form onSubmit={handleFileUpload}>
          <h2 className="text-xl font-semibold mb-4">Importar Dispositivos desde Archivo</h2>
          <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={handleFileChange} className="mb-4" />
          <button type="submit" className="bg-[#31a749] text-white py-2 px-4 rounded-md hover:bg-green-700">Importar Dispositivos</button>
        </form>
      )}

      {activeTab === 'export' && (
        <div>
          <h2 className="text-xl font-semibold mb-4">Exportar Reportes</h2>
          <div className="flex gap-4 mb-4">
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="border border-gray-300 rounded-md p-2" />
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="border border-gray-300 rounded-md p-2" />
          </div>
          <div className="flex gap-4">
            <button onClick={() => handleExport('completed')} className="bg-[#31a749] text-white py-2 px-4 rounded-md">Exportar Completados</button>
            <button onClick={() => handleExport('pending')} className="bg-yellow-500 text-white py-2 px-4 rounded-md">Exportar Pendientes</button>
            <button onClick={() => handleExport('all')} className="bg-blue-500 text-white py-2 px-4 rounded-md">Exportar Todo</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PhoneForm;
